import React from 'react';
import { RegionSelectorMobile } from "src/components/RegionSelectorMobile";
import { RegionSelectorDesktop } from "src/components/RegionSelectorDesktop";
import { CountrySelectorDesktop } from "src/components/CountrySelectorDesktop";
import { CountrySelectorMobile } from "src/components/CountrySelectorMobile";
import { AccountTypes, WeblabedFeatures } from "src/components/Types";
import { useAccountContext } from "src/components/AccountContextProvider";
import { findFeatureLaunchInfo } from "src/components/utils";

type CardContentTypeSelectorProps = {
  isMobile: boolean | undefined;
};
export const CardContentTypeSelector: React.VFC<CardContentTypeSelectorProps> = ({isMobile}) =>
    {
        const {
            hasNestedAccounts,
            selectedAccountType,
            selectedAccount
        } = useAccountContext();
        if (!hasNestedAccounts) {
            return null;
        }
        const shouldDisplayRegionalSelector = (
            selectedAccountType === AccountTypes.MANAGER ||
            selectedAccount?.nestedAccounts?.some(account => 
                account?.accountType === AccountTypes.DSP_ADVERTISER
            )
        ) ?? false;
        
        if (shouldDisplayRegionalSelector) {
            return isMobile ? (<RegionSelectorMobile/>) : (<RegionSelectorDesktop/>);
        }
        // Default behavior is to render CountrySelector component to populate the view with
        // the empty, (but styled), div
        return isMobile ? (<CountrySelectorMobile/>) : (<CountrySelectorDesktop/>);
    }
